<template>
  <div>
    <div
      v-if="!rows.length && dataLoading"
      class="loading-container text-center p-1"
    >
      <span
        class="spinner-border mr-1"
        role="status"
        aria-hidden="true"
      />
      Fetching Data.....
    </div>
    <div
      v-if="!rows.length && !dataLoading"
      class="loading-container text-center p-1"
    >
      There are no records to display
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
    dataLoading: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style scoped>

@media (max-width: 768px) {
  .loading-container {
    width: 75vw;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    box-sizing: border-box;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .loading-container {
    width: 85vw;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    box-sizing: border-box;
  }
}
</style>
